<app-page-header title="Apps" origin="Home" routerLink="/"></app-page-header>

<div class="row">
    <div class="card-body">
        <app-table-guru [actionButtonText]="buttonText" [showActionButton]="true" (actionButtonClicked)="openModal({})" [apiEndpoint]="'/office/clients'" [columnMapping]="[
            { key: 'name', label: 'Naam' },
            { key: 'type', label: 'Type' },
            { key: 'service_provider', label: 'Service provider' },
            { key: 'is_eduv', label: 'EduV', type: 'boolYesNo' },
            { key: 'has_external', label: 'Uitgaande connectie', type: 'boolYesNo' },
            { key: 'revoked', label: 'Uitgeschakeld', type: 'boolYesNo' },
            { key: 'created_at', label: 'Toegevoegd op', type: 'date' },
            { key: 'updated_at', label: 'Gewijzigd op', type: 'date' },
          ]" 
          [itemsPerPage]="10" [openModalComponent]="editFormReference" [reload]="reloadItems">
        </app-table-guru>
    </div>
</div>
